import { INTERNAL_ORG_ID } from '@/constants';

import { Grant, GrantContext, GrantResult, UserPrivilegeMap } from '../types';

export class InternalPrivilegeGrant implements Grant {
  constructor(
    public readonly privilege: string,
    private userPrivilegeMap?: UserPrivilegeMap
  ) {}

  async allowed(_context: GrantContext): Promise<GrantResult> {
    if (!this.userPrivilegeMap) {
      return undefined;
    }

    const internalOrgPrivileges = this.userPrivilegeMap.get(INTERNAL_ORG_ID);

    if (!internalOrgPrivileges) {
      return false;
    }

    return internalOrgPrivileges.has(this.privilege);
  }

  withPrivilegeMap(userPrivilegeMap: UserPrivilegeMap): InternalPrivilegeGrant {
    return new InternalPrivilegeGrant(this.privilege, userPrivilegeMap);
  }
}
